import NavbarUser from './NavbarUser'
import NavbarBookmarks from '../NavbarBookmarks'

const ThemeNavbar = ({skin, setSkin, setMenuVisibility}) => {

    return (
        <>
            <div className='bookmark-wrapper d-flex align-items-center'>
                <NavbarBookmarks setMenuVisibility={setMenuVisibility}/>
            </div>
            <NavbarUser skin={skin} setSkin={setSkin}/>
        </>
    )
}

export default ThemeNavbar